export default {
  guest: {
    earn_pts: 'Optjen {{points}} point på denne bestilling',
    tagline: 'Bliv belønnet. Hver gang du bestiller.',
    pick_reward: 'Vælg, hvad du vil have, når du når dertil',
    free_at: 'gratis ved {{points}} point',
    save_at: 'spar {{amount}} ved {{points}} point',
    nearest: 'nærmeste',
    cta: 'Begynd at optjene – det er gratis',
    already_member: 'Er du allerede medlem?',
    sign_in: 'Log ind',
  },
  member: {
    earning_free: 'Du optjener gratis mad',
    every_euro_one: 'Hver {{amount}} du bruger = 1 point. Indløs til gratis varer og rabatter.',
    every_euro_other: 'Hver {{amount}} du bruger = {{count}} point. Indløs til gratis varer og rabatter.',
    until_redeem: '{{remaining}} point, til du kan begynde at indløse',
    unlock_first: 'Alene denne bestilling låser op for din første belønning!',
    so_close: 'Så tæt på gratis mad!',
    just_more: 'Bare {{remaining}} point mere, så kan du begynde at spare.',
    pts_to_unlock: '{{remaining}} point til at låse belønninger op',
    this_order_unlocks: 'Denne bestilling bringer dig op på {{points}} point – du kan indløse dem på næste bestilling!',
    save_next: 'Spar op til {{amount}} næste gang',
    pts_from_order: '+{{earned}} point fra denne bestilling – kun {{remaining}} tilbage bagefter!',
    rewards_value: '= {{amount}} i belønninger',
    save_this_order: 'Spar op til {{amount}} på denne bestilling',
    use_pts: 'Brug dine {{points}} point ved betaling',
    earned_this_order: '+{{points}} point optjent på denne bestilling',
    current: 'Nuværende',
    from_this_order: '+{{points}} fra denne bestilling',
    expiration_zero: '{{points}} point udløber i dag',
    expiration_one: '{{points}} point udløber om 1 dag',
    expiration_other: '{{points}} point udløber om {{count}} dage',
  },
};
